import { createSlice } from '@reduxjs/toolkit';
import { fetchSuperUserRegions, fetchAllTrainers } from '../thunks/trainingThunks/thunk';

const initialState = {
  loading: false,
  error: null,
  data: {
    regions: [],
    trainers: [],
    totalTrainerRecords: 0,
  },
  total: 0,
  page: 1,
  limit: 100,
};

const trainersSlice = createSlice({
  name: 'trainersSlice',
  initialState,
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setLimit(state, action) {
      state.limit = action.payload;
    },
    removeTrainer(state, action) {
      const { employeeId } = action.payload; // Get employeeId from the action payload
      state.data.trainers = state.data.trainers.filter(
        (trainer) => trainer.employeeId !== employeeId
      );
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchSuperUserRegions
      .addCase(fetchSuperUserRegions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuperUserRegions.fulfilled, (state, action) => {
        state.loading = false;
        state.data.regions = action.payload;
      })
      .addCase(fetchSuperUserRegions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handle fetchAllTrainers
      .addCase(fetchAllTrainers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTrainers.fulfilled, (state, action) => {
        state.loading = false;
        state.data.trainers = action.payload.trainers;
        state.data.totalTrainerRecords = action.payload.totalTrainerRecords;
      })
      .addCase(fetchAllTrainers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPage, setLimit, removeTrainer } = trainersSlice.actions;

export default trainersSlice.reducer;
